import React from 'react'
import { List, withDataProvider } from 'react-admin'
import Pagination from '../../elements/Pagination'
import SegmentsListFilters from './SegmentsListFilters'
import Segments from './Segments'
import useTestTypesList from '../../utils/useTestTypesList'
import useCompetencesList from '../../utils/useCompetencesList'
import useCriteriasList from '../../utils/useCriteriasList'
import useModulesList from '../../utils/useModulesList'
import {createStyles, WithStyles, withStyles} from "@material-ui/core/styles";

interface ISegmentsList extends WithStyles{
  statusId: any,
  assignId: number,
  dataProvider: any,
  dispatch: any,
  isArchived?: boolean
}
const styles = () => createStyles({
  filter: {
    paddingLeft: '150px',
    minWidth: '168px'
  }
})

const SegmentsList = withStyles(styles)(({
  classes,
  statusId,
  assignId,
  dispatch,
  dataProvider,
  isArchived,
  ...props
}: ISegmentsList) => {
  const types = useTestTypesList()
  const competences = useCompetencesList()
  const criterias = useCriteriasList()
  const modules = useModulesList()

  const levelTypes = [
    { id: 'test', name: 'Базовый уровень' },
    { id: 'case', name: 'Основной уровень' },
    { id: 'situation', name: 'Квалификационный уровень' }
  ]

  return (
    <>
      <List
        {...props}
        exporter={false}
        filter={!isArchived && { statusId, assignId }}
        filters={(
          <SegmentsListFilters
            className={classes.filter}
            levelTypes={levelTypes}
            statusId={statusId}
            isArchived={false}
          />
        )}
        pagination={<Pagination rows={[10, 20, 50]} />}
        bulkActionButtons={false}
      >
        <Segments
          dispatch={dispatch}
          dataProvider={dataProvider}
          types={types}
          competences={competences}
          criterias={criterias}
          modules={modules}
          isArchived={isArchived}
          statusId={statusId}
        />
      </List>
    </>
  )
})


export default withDataProvider(SegmentsList)
